import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Events } from "./Events/Events";
import { Modes } from "./Modes/Modes";
export var Interactivity = /*#__PURE__*/function () {
  function Interactivity(engine, container) {
    _classCallCheck(this, Interactivity);

    this.detectsOn = "window";
    this.events = new Events();
    this.modes = new Modes(engine, container);
  }

  _createClass(Interactivity, [{
    key: "detect_on",
    get: function get() {
      return this.detectsOn;
    },
    set: function set(value) {
      this.detectsOn = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$detectsOn;

      if (!data) {
        return;
      }

      var detectsOn = (_data$detectsOn = data.detectsOn) !== null && _data$detectsOn !== void 0 ? _data$detectsOn : data.detect_on;

      if (detectsOn !== undefined) {
        this.detectsOn = detectsOn;
      }

      this.events.load(data.events);
      this.modes.load(data.modes);
    }
  }]);

  return Interactivity;
}();